// extracted by mini-css-extract-plugin
export default {"card":"launcher-module__card--WfVZ8","infoBage":"launcher-module__infoBage--_p7hM","imgContainer":"launcher-module__imgContainer--buvq3","bubble":"launcher-module__bubble--LKl7E"};